import { onMounted, onUnmounted, ref } from 'vue'
import debounce from 'lodash/debounce'

export default () => {
  const windowHeight = ref(typeof window !== 'undefined' ? window.innerHeight : null)
  const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : null)

  const resize = debounce(() => {
    windowHeight.value = window.innerHeight
    windowWidth.value = window.innerWidth
  }, 50)

  onMounted(() => {
    resize()
    window.addEventListener('resize', resize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', resize)
  })

  return { windowHeight, windowWidth }
}